import {makeComponent, PageContainer, RenderEvent} from '../../core';
import React from 'react';
import {executeCommands} from '../../core/StatementRunner';
import { ScreenRef } from 'core/ActionEvent';
import { IPageLaunchParams } from 'core/types';
import { Dialog } from 'core/Dialog';

export const AppSqlHost = makeComponent(class extends React.Component<{event?:RenderEvent,$elem?:any,page?:IPageLaunchParams}>{
    

    render(){
        let html = {__html:this.props.$elem.html};
        return <div onClick={this.handleClick} style={{marginLeft:400}} dangerouslySetInnerHTML={html}/>
    }

    handleClick = (e:React.MouseEvent) => {
        let event = this.props.event;
        let page:IPageLaunchParams = {
           // "name": "pages/Sales/cart_dashboard:default",
            "name":"appsql:test.record",
            props:{
                "@cart_id": "4247f806-cdaa-4ae5-8fce-db15044d4d38",
                "@cust_id":"0000"
            }
        }
        let dialog = <PageContainer page={page} layer='appsql'/>
        return Dialog.open(event.canvas,dialog,null,"appsql");
    }
    render1(){
        let page = this.props.page;
        return (<sqx-frame src={page.name}></sqx-frame>)
    }

    
    render2(){
      
        let event = this.props.event;
        let content = this.props.$elem.content;
    
        let attr = makeAttr({});
        return (<div onClick={this.handleClick}>
            {renderChildren(attr,content)}
        </div>)
    }
    
    
    handleClick2 = async (e:React.MouseEvent) => {
        let target = e.target as HTMLElement;
        let actionElem = target.closest('[sqx-action]');
        if (!actionElem) return;
        e.preventDefault();
        e.stopPropagation();
        let action = actionElem.getAttribute("sqx-action");
        if (action == "open"){
            let pageName = actionElem.getAttribute("sqx-page");
            let canvas = this.props.event.canvas;
            let screenRef = new ScreenRef(canvas,{});
            let paramAttr = actionElem.getAttribute("sqx-params");
            let params = [];
            if (paramAttr){
                let paramObj = JSON.parse(paramAttr);
                for(let key in paramObj){
                    params.push({$kind:"Pass",name:key,value:JSON.stringify(paramObj[key])})
                }
            }
            let statements = [
            //    {$kind:"OpenPage",name:"'pages/Sales/branch_search:default'",params:[]}
                {$kind:"OpenPage",name:"'" + pageName + "'",params}
            ];
            await executeCommands(screenRef,statements);
            canvas.update();
        }
    }
        
});

const Section = ({attr,key,style,children}) => {
    return (<div key={key} style={attr(style)} className="my-section">{attr(children)}</div>)
}

const DataField = ({key,attr,label,value}) => {
    return (<div key={key} data-field sqx-action='open' sqx-page='pages/Sales/branch_search:default' sqx-params={JSON.stringify({"@cust_id":"0001"})}>
        <label>{attr(label)}</label>
        <div>{attr(value)}</div>
    </div>)
}


function makeAttr(scope){
    let attr:any = function(prop,index?){
        if (!prop) return prop;
        let fieldRef = prop["$="];
        if (fieldRef){
            let rec = attr.scope[fieldRef[0]];
            if (!rec || rec.length == 1) return rec;
            return rec[fieldRef[1]];
        }
        if (Array.isArray(prop)){
            return renderChildren(attr,prop,index || 0);
        }
        if (prop.$){
            return renderTag(attr,prop,index || 0);
        }
        return prop;
    }
    attr.scope = scope;
    return attr;
}




function renderTag(attr,elem,index?){
   
    if (elem.scope){
        attr = makeAttr({...attr.scope,...elem.scope})
    }
    let props = {...elem.props,children:elem.children,attr};
    if (index){
        props.key = index;
    }
    if (elem.$ == "section"){
        return Section(props);
    }
    if (elem.$ == "data-field"){
        return DataField(props);
    }
    if (elem.$ == "text-elem"){
        return <span key={index}>{attr(props.value)}</span>
    }
    if (elem.$ =="html"){
        let html = {__html:elem.html};
        return <div key={index} style={{display:"contents"}} dangerouslySetInnerHTML={html}/>
    }
    return (<div key={index}>{attr(elem.children)}</div>);
}

function renderChildren(attr,children:any[],index?){
    if (!children) return null;
    if (!Array.isArray(children)){
        return attr(children,index);
    }
    let out = [];
    for(let i = 0; i < children.length;i++){
        let child = children[i];
        out.push(attr(child,i + 1))
    }
    return out;
}